import '../../account_settings/acd_round_robin_with_assignation_limit_and_priority_setting_view.js.coffee';# Added by Script
import '../../account_settings/acd_round_robin_with_assignation_limit_setting_view.js.coffee';# Added by Script
Monitoring.Views ||= {}

class AccountSettings.AcdSettingView extends Backbone.View
  template: JST["backbone/templates/account_settings/acd_setting/acd_setting"]

  operatorsDistributionSettingViews:
    'round_robin_with_assignation_limit': AccountSettings.AcdRoundRobinWithAssignationLimitSettingView
    'round_robin_with_assignation_limit_and_priority': AccountSettings.AcdRoundRobinWithAssignationLimitAndPrioritySettingView

  events:
    'change #acd-setting-active': 'onAcdActiveChange'
    'change #acd-prioritize-non-replied': 'onAcdPrioritizeNonRepliedChange'
    'change #acd-setting-cases-order': 'onAcdCasesOrderChange'
    'change #acd-setting-operators-distribution': 'onAcdOperatorsDistributionChange'
    'click #acd-save': 'onClickSave'

  initialize: (@options = {}) ->
    @acdSetting = @options.acdSetting
    @public_filters = @options.public_filters_info

  render: =>
    @operatorsDistributionSettingView.remove() if @operatorsDistributionSettingView
    @$el.html(@template(@))
    @renderOperatorsDistributionSettings(@acdSetting.get('operators_distribution'))
    @initializeToggle()
    @renderSettingsByFilter()


  initializeToggle: ->
    @$el.find('#acd-setting-active').bootstrapToggle({
      # 'on' and 'off' options can be set here
    })
    @$el.find('#acd-prioritize-non-replied').bootstrapToggle({
      # 'on' and 'off' options can be set here
    })

  renderOperatorsDistributionSettings: (operatorsDistribution) =>
    @operatorsDistributionSettingView.remove() if @operatorsDistributionSettingView
    @operatorsDistributionSettingView = new @operatorsDistributionSettingViews[operatorsDistribution]({acdSetting: @acdSetting})
    @$el.find('.acd-setting-operators-settings-view-container').append(@operatorsDistributionSettingView.render().el)

  renderSettingsByFilter: ->
    @acdSettingsByFilter = @acdSetting.get('settings_by_group_and_filter')
    teamsAndFiltersSettings = {}
    _.each(@acdSettingsByFilter, (attrs, teamName)=>
      teamsAndFiltersSettings[teamName] = {
        teamName: teamName
        teamsAndFiltersPriorization: @addFilterNameToFilterIds(attrs.prioritization)
        publicFilters: @public_filters
        active: attrs.active
        assignation_limit: attrs.assignation_limit
      }
    )
    @acdSettingsByFilterView = new AccountSettings.AcdSettingsByFilterView({teamsAndFiltersSettings: teamsAndFiltersSettings})
    @$el.find('.acd-settings-by-filter').html(@acdSettingsByFilterView.render().$el)

  addFilterNameToFilterIds: (filters)->
    _.each(filters, (filter)=>
      filter.filterName = filter.display_name
    )
    filters

  onAcdActiveChange: ->
    isActive = @$el.find("#acd-setting-active").prop('checked')
    @acdSetting.set('active', isActive)

  onAcdPrioritizeNonRepliedChange: ->
    isActive = @$el.find("#acd-prioritize-non-replied").prop('checked')
    @acdSetting.set('reply_prioritization_active', isActive)

  onAcdCasesOrderChange: ->
    casesOrder = @$el.find("#acd-setting-cases-order").val().trim()
    @acdSetting.set('cases_order', casesOrder)

  onAcdFilterChange: ->
    casesOrder = @$el.find("#acd-setting-cases-order").val().trim()
    @acdSetting.set('cases_order', casesOrder)

  onAcdOperatorsDistributionChange: ->
    operatorsDistribution = @$el.find("#acd-setting-operators-distribution").val().trim()
    @acdSetting.set('operators_distribution', operatorsDistribution)
    @renderOperatorsDistributionSettings(operatorsDistribution)

  onClickSave: ->
    operator_distribution_settings_validation_error = @operatorsDistributionSettingView.validateSetting()
    if operator_distribution_settings_validation_error
      window.showWarning(operator_distribution_settings_validation_error)
    else
      @$el.find('.saving').html(I18n.t('monitoring.acd_setting.saving'))
      acdSettingsByFilter = @acdSettingsByFilterView.getSettingsByFilter()
      @acdSetting.set('group_names', [])
      @acdSetting.set('settings_by_group', {})
      @acdSetting.set('settings_by_group_and_filter', acdSettingsByFilter)

      isTeamActive = @$el.find("#acd-setting-only-team-active").prop('checked')
      @acdSetting.set('acd_by_group', false)
      @acdSetting.set('acd_by_group_and_filter', true)
      @acdSetting.save({}, {
        complete: () =>
          @$el.find('.saving').html(I18n.t('monitoring.acd_setting.save'))
        success: (_, response) =>
          if(response.success)
            @acdSetting.set('digest', response.acdSetting.digest)
            window.showSuccess(I18n.t('monitoring.acd_setting.successful_save'))
          else
            window.showError(I18n.t('monitoring.acd_setting.team_without_active_sources'))
        error: (_, response) =>
          window.showError(response.responseText)
          console.log("Error updating ACD settings: #{response.responseText}")
      })
    false
